//@todo Refactor this so we're not lazily using jQuery
const $ = require('jquery');

const urls = {
    local: {
        searchLocations: '/api/local/search-locations',
        locations: '/api/local/locations',
        searchForBooking: '/api/local/search-for-booking',
        fetchRecentBooking: '/api/local/fetch-recent-booking',
    },
    remote: {
        search: '/api/remote/search/vehicles',
    },
};

function fetchStoredLocations() {
    return new Promise((resolve, reject) => {
        $.getJSON(urls.locations)
            .then(resolve, reject);
    });
}

function getVehiclesAndTypesForLocation(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST',
            url: urls.remote.search,
            dataType: 'json',
            data,
            cache: false,  // CRITICAL: Prevent Chrome from caching vehicle search results
            headers: {
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                'Pragma': 'no-cache',
                'Expires': '0'
            }
        })
            .then(response => {
                if (response.error) {
                    reject(response);
                }
                else {
                    resolve(response);
                }
            }, response => {
                reject(response);
            });
    });
}

function getInsuranceOptions(data) {
    return new Promise((resolve, reject) => {
        getVehiclesAndTypesForLocation(data)
            .then(vehicles => {
                let result = {};

                for (let vehicle of vehicles) {
                    if (data.vehicle_slug && vehicle.slug !== data.vehicle_slug) {
                        continue;
                    }

                    for (let coverage of Object.entries(vehicle.coverage_options)) {
                        result[coverage[0]] = coverage[1];
                    }
                }

                resolve(result);
            }, error => {
                reject(error);
            })
    });
}

function searchForBooking(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'POST',
            url: urls.local.searchForBooking,
            dataType: 'json',
            data,
        })
            .then(response => {
                if (response.error || !response.booking) {
                    reject(response);
                }
                else {
                    resolve(response);
                }
            }, response => {
                reject(response);
            });
    });
}

function fetchRecentBooking(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url: urls.local.fetchRecentBooking,
            dataType: 'json',
            data
        })
            .then(response => {
                if (response.error) {
                    reject(response);
                }
                else {
                    resolve(response[0]);
                }
            }, response => {
                console.error('error with response?', response);
                reject(response);
            });
    });
}

function searchLocations(data) {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: 'GET',
            url: urls.local.searchLocations,
            dataType: 'json',
            data,
        })
            .then(response => {
                if (response.error) {
                    reject(response);
                }
                else {
                    resolve(response);
                }
            }, response => {
                console.error('Error with response?', response);
                reject(response);
            })
    });
}

const local = {
    searchLocations,
    fetchStoredLocations,
    searchForBooking,
    fetchRecentBooking,
};

const remote = {
    getVehiclesAndTypesForLocation,
    getInsuranceOptions,
};

export {
    urls,
    local,
    remote,
};
